/**
 * Nosto feature flags.
 *
 * The two Nosto theme settings (Theme settings > Nosto) are mirrored onto <html> as
 * classes by layout/theme.liquid. Reading them here lets the bundled Nosto modules stay
 * in custom.js while doing nothing when the feature is switched off — so turning Nosto
 * back on is a checkbox in the theme editor, not a CodeKit rebuild and a deploy.
 *
 * The classes are server-rendered, so they are present before any of this runs and
 * cannot change during the life of the page.
 *
 * See docs/Nosto.md > Toggling Nosto on and off.
 */

const root = document.documentElement;

/** Product page carousel, cart drawer suggestions, and any other Nosto placement. */
export function recommendationsEnabled() {
  return root.classList.contains('nosto-reco-on');
}

/** Nosto Search: header autocomplete, search results page, category merchandising. */
export function searchEnabled() {
  return root.classList.contains('nosto-search-on');
}

/** For behaviour shared by both — anything keyed off <nosto-dynamic-card>. */
export function anyEnabled() {
  return recommendationsEnabled() || searchEnabled();
}
